/**
 * Created by katarinababic on 20.11.24.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useRootStore } from '../../Store/useRootStore';
import { useParams } from 'react-router-dom';
import { ExploreContentBuilder, KinasticContent } from '../../Model/Explore/ExploreContentBuilder';
import { ExploreEntry } from '../../Model/Explore/ExploreEntry';
import { ExploreContentViewRenderer } from '../../Components/EntryView/ExploreContentViewRenderer';
import { RelatedEntriesView } from '../../Components/RelatedEntriesView';
import { ExploreCategory } from '../../Model/Explore/ExploreCategory';
import { Container } from 'reactstrap';
import { ExploreContentViewCategoryRenderer } from '../Academy/View/CategoryView/ExploreContentViewCategoryRenderer';
import { ContentNotFound } from '../../Components/EntryView/ContentNotFound';

export type MentalHealthContentViewScreenProps = {};

export const MentalHealthContentViewScreen: React.FC<MentalHealthContentViewScreenProps> = observer((props) => {
  const { analytics } = useRootStore();

  const { contentId } = useParams<{ contentId: string }>();

  const [content, setContent] = useState<KinasticContent | undefined>();
  const [lastError, setLastError] = useState<unknown>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setContent(undefined);
    setLastError(undefined);
    if (contentId) {
      setLoading(true);
      ExploreContentBuilder.findOne(contentId)
        .then((res) => setContent(res))
        .catch((e: unknown) => setLastError(e))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [contentId]);

  useEffect(() => {
    if (content) {
      const type = content.type === 'recipe' ? 'recipe' : content.type;
      analytics.logSelectContent(type, content.id);
    }
  }, [analytics, content]);

  if (content) {
    if ('contentType' in content && content.contentType === 'category') {
      return (
        <Container>
          <ExploreContentViewCategoryRenderer category={content as ExploreCategory} linkPrefix={'/mental-health/'} />
        </Container>
      );
    }
    const exploreEntry = 'backgroundImage' in content ? content : undefined;
    return (
      <React.Fragment>
        <ExploreContentViewRenderer entry={content} />
        {exploreEntry && <RelatedEntriesView entry={exploreEntry as ExploreEntry} linkPrefix={'/mental-health/'} />}
      </React.Fragment>
    );
  }

  if (loading) {
    return <Container style={{ padding: '48px', textAlign: 'center' }}>Loading...</Container>;
  }

  return lastError ? <ContentNotFound /> : null;
});
